export default class FormSubmissionLike {
  constructor(json) {
    this.likedBy = json.liked_by
    this.occurredAt = json.occurred_at
  }

  likedBy: string
  occurredAt: string
}
